module.exports = __webpack_public_path__ + "img/payme_logo1.c8179527.png";